import { cn } from '@bem-react/classname';

import type { IPublicationFilters } from '@typings/IPublicationFilters';

export const cnIndex = cn('Index');
export const indexCn = cnIndex();

export const indexLinkCn = cnIndex('Link');
export const indexSearchCn = cnIndex('Search');
export const indexSearchFormCn = cnIndex('Search-Form');
export const indexSearchSpoilerCn = cnIndex('Search-Spoiler');
export const indexSearchButtonCn = cnIndex('Search-Button');
export const indexSearchButtonContainer = cnIndex('SearchButtonContainer');
export const indexSearchButtonIconCn = cnIndex('Search-Button-Icon');
export const indexSearchInputCn = cnIndex('Search-Input');
export const indexSearchSwitchCn = cnIndex('Search-Switch');
export const indexSearchMiniInputCn = cnIndex('Mini-Input');
export const indexMapCn = cnIndex('Map');
export const indexControlsCn = cnIndex('Controls');

export const defaultFilters: IPublicationFilters = {
    country: 0,
    city: 0,
    heating: false,
    oven: false,
    dishwasher: false,
    balcony: false,
    animal: false,
    conditioner: false,
    microwave: false,
    bathroom: 0,
};

export const INDEX_COUNT_PUBLICATIONS = 5;
